module.exports = __webpack_public_path__ + "static/media/medical.1c764113.png";